import { GenerateQueriesArgs, generateQueries } from 'src/queries/queryGenerator'
import { RequestableProduct } from 'src/types'

export const REQUESTABLE_PRODUCTS_ENDPOINT = 'seller/requestable_products'
export const REQUESTABLE_PRODUCTS_QUERY_KEY = 'requestable_products'

export interface RequestableProductQueryParams {
  categoryId?: Id
  name?: string
  sellerCompanyId?: Id
  verticalId?: Id
  ordering?: 'name' | '-name'
  limit?: number
  withTemplate?: boolean
}

const generateQueriesConfig: GenerateQueriesArgs<
  RequestableProduct,
  RequestableProductQueryParams
> = {
  endpoint: REQUESTABLE_PRODUCTS_ENDPOINT,
  queryKey: REQUESTABLE_PRODUCTS_QUERY_KEY,
  useAllEntitiesQueryArgs: {
    queryOptions: {
      cacheTime: 1000 * 60 * 120,
      staleTime: 1000 * 60 * 60,
    },
  },
}

export const {
  useSingleEntityQuery: useRequestableProductQuery,
  useAllEntitiesQuery: useRequestableProductsQuery,
  useRecursiveQuery: useRecursiveRequestableProductsQuery,
} = generateQueries(generateQueriesConfig)
